import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import '@/app.css';
import '@/themes/tokens.css';
import App from '@/App';
import { cognitoConfig } from '@/security/cognito-config';

const AUTH_MODE = import.meta.env.VITE_AUTH_MODE || 'dev';

if (AUTH_MODE === 'cognito') {
  Amplify.configure(cognitoConfig);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
